import { render } from "./RatesDataTable.vue?vue&type=template&id=851fe5d4&scoped=true&ts=true"
import script from "./RatesDataTable.vue?vue&type=script&lang=ts"
export * from "./RatesDataTable.vue?vue&type=script&lang=ts"

import "./RatesDataTable.vue?vue&type=style&index=0&id=851fe5d4&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851fe5d4"]])

export default __exports__